import { IconWrapper } from '../runtime';
export default IconWrapper('radiation', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48"
    }
  }, [h("g", {
    "attrs": {
      "stroke": "none",
      "stroke-width": props.strokeWidth,
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [h("g", {
    "attrs": {
      "transform": "translate(4.000000, 6.000000)"
    }
  }, [h("circle", {
    "attrs": {
      "fill": props.colors[0],
      "cx": "20.0036696",
      "cy": "18",
      "r": "3"
    }
  }), h("path", {
    "attrs": {
      "d": "M15.0405459,25.4759893 C16.4625532,26.4194367 18.1673051,26.9687808 20,26.9687808 C21.8326949,26.9687808 23.5374468,26.4194367 24.9594541,25.4759893 L31.0210091,34.6826856 C27.8609928,36.7792354 24.0726554,38 20,38 C15.9273446,38 12.1390072,36.7792354 8.97899086,34.6826856 L15.0405459,25.4759893 Z M11.0158888,18.4840224 L0.0353083641,19.1449814 C0.0118800062,18.7474045 0,18.3467124 0,17.9432378 C0,10.0911138 4.49943957,3.29287286 11.0537715,4.05231404e-14 L15.9741972,9.86878078 C13.0247478,11.3505736 11,14.409782 11,17.9432378 C11,18.1248014 11.005346,18.3051128 11.0158888,18.4840224 Z M24.0258028,9.86878078 L28.9462285,-3.55271368e-15 C35.5005604,3.29287286 40,10.0911138 40,17.9432378 C40,18.3467124 39.98812,18.7474045 39.9646916,19.1449814 L28.9841112,18.4840224 C28.994654,18.3051128 29,18.1248014 29,17.9432378 C29,14.409782 26.9752522,11.3505736 24.0258028,9.86878078 Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "fill": props.colors[1],
      "fill-rule": "nonzero",
      "stroke-linejoin": props.strokeLinejoin
    }
  })])])]);
});